import HomePageTemplate1 from '../../components/HomePageTemplates/HomePageTemplate1';
import { GEO_LOCATION_CONFIG } from '../../data/geo_location_config';

export default function Home() {
	return <HomePageTemplate1 geoConfig={GEO_LOCATION_CONFIG.US} />;
}
